// @flow
import {createTheme} from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';
import {colors} from './assets/styles/colors';

export const theme = createTheme({
  palette: {
    background: {
      default: '#FFFFFF',
    },
    primary: {
      main: colors.purple3,
    },
    secondary: {
      main: '#E9943F',
    },
    error: red,
    success: {
      main: colors.success,
    },
  },
  typography: {
    fontFamily: '"Poppins", "Muli", sans-serif',
  },
  borderRadius: 5,
  spacing: x => `${x * 8}px`,
});
